var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,{tag:"component",attrs:{"category":_vm.category,"grouping":_vm.rowGrouping,"name":_vm.rowName,"show-thumbnail":true,"thumbnail-url":_vm.thumbnailUrl},on:{"row-clicked":_vm.rowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }